// extracted by mini-css-extract-plugin
export var image = "cc_dr";